import { createSelector } from 'reselect'
import { memoize } from '@exodus/basic-utils'

const selectorFactory = (createAssetIncomingOrdersSelector) =>
  memoize(
    ({ assetNames, walletAccount }) =>
      createSelector(
        ...assetNames.map((assetName) =>
          createAssetIncomingOrdersSelector({ assetName, walletAccount })
        ),
        (...incomingOrderSets) => incomingOrderSets.some((orderSet) => orderSet.size > 0)
      ),
    ({ assetNames, walletAccount }) => `${assetNames.join('.')}_${walletAccount}`
  )
const createAssetsHaveIncomingOrdersSelectorDefinition = {
  id: 'createAssetsHaveIncomingOrders',
  selectorFactory,
  dependencies: [{ selector: 'createAssetSourceIncomingOrders' }],
}

export default createAssetsHaveIncomingOrdersSelectorDefinition
